import Heading from "../heading";
import RichText from "../rich-text";

const getHeading = (level) => {
  return ({ content }) => (
    <Heading level={level}>
      <RichText content={content} />
    </Heading>
  );
};

export default getHeading;
